/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BUTTON_FORMAT_SOFT, BUTTON_THEME_DEFAULT, Button, Card, CardProps, DialogContentProps } from '@squiz/sds';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFileStore } from '../../../../../../../../Services/file-store';
import { FILE_EXPLORER_STRINGS } from '../../../../FileExplorer.constants';
import { InformationDialogContentProps } from './InformationDialogContent.props';

export const InformationDialogContent = (props: DialogContentProps): JSX.Element => {
  const { t } = useTranslation();

  const { close, setButtonKeys, setButtons } = props;

  const itemProps = props.customProps as InformationDialogContentProps;
  const { id, urls } = itemProps;

  const labels = useMemo(
    () => ({
      close: t(FILE_EXPLORER_STRINGS.close),
      fileFolderId: t(FILE_EXPLORER_STRINGS.fileFolderId),
      fileFolderIdCopyUrl: t(FILE_EXPLORER_STRINGS.fileFolderId),
      information: t(FILE_EXPLORER_STRINGS.information),
      url: t(FILE_EXPLORER_STRINGS.url),
    }),
    [t],
  );

  const { loadingState } = useFileStore();

  useEffect(() => {
    const closeButton = (
      <Button
        classes="file-explorer__information-dialog-btn--close"
        format={BUTTON_FORMAT_SOFT}
        onClick={(): void => close()}
        text={labels.close}
        theme={BUTTON_THEME_DEFAULT}
      />
    );

    setButtonKeys([`close`]);
    setButtons([closeButton]);
  }, [close, labels, loadingState, setButtonKeys, setButtons]);

  const fileFolderIdCardProps: CardProps = {
    content: id,
    format: 'standard',
    showCopyIcon: true,
    title: labels.fileFolderIdCopyUrl,
  };

  const urlCardProps = (url: string, index: number): CardProps => ({
    content: url,
    format: 'standard',
    showCopyIcon: true,
    title: `${labels.url} ${index + 1}`,
  });

  return (
    <div className="dam-information__container">
      <div className="sds-dialog__heading custom">
        <span>{labels.information}</span>
      </div>
      <div className="dam-information__cards-container">
        <Card {...fileFolderIdCardProps} classes={'dam-information__card file-folder-id'} />
      </div>
      <div className="dam-information__cards-container">
        {urls.map((url, index) => (
          <Card {...urlCardProps(url, index)} classes={'dam-information__card url-card'} key={index} />
        ))}
      </div>
    </div>
  );
};
